<script setup lang="ts">
const {
  disabled = false,
} = defineProps<{ disabled?: boolean }>()

const model = defineModel({
  default: false,
})
</script>

<template>
  <div class="relative inline-flex items-center">
    <input
      v-model="model"
      type="checkbox"
      :disabled="disabled"
      class="peer sr-only"
    />
    <div
      class="flex size-5 items-center justify-center rounded peer-checked:bg-[--theme-lighter] peer-focus:border-[--theme-light] peer-focus:ring-1 peer-focus:ring-[--theme-light]"
      :class="{
        'border-2 border-[--theme-lightest]': !model,
        'hover:border-none hover:bg-[--theme-lighter]': !disabled,
      }"
    >
      <UIcon
        v-if="model"
        name="check"
        class="text-black"
        size="xxs"
      />
    </div>
  </div>
</template>
